import { Check } from '@mui/icons-material';
import { Box, Button, FormControl, Grid2, MenuItem, Stack } from '@mui/material';
import { OutlinedTextField } from '@my2n/react-hook-form-inputs';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import Recaptcha from 'react-recaptcha';
import { PasswordInput } from '../../components/HookFormFields/PasswordInput';
import messages from './messages';
import { getFeedbackOptions } from './referererOptions';
import { RegisterGtc } from './RegisterGtc';
import { IRegisterFormData } from './validationSchema';

export interface IRegisterFormProps {
  isOryRegistrationFFEnabled?: boolean;
  isLoading?: boolean;
}
export function RegisterForm({ isLoading, isOryRegistrationFFEnabled }: IRegisterFormProps) {
  const { formatMessage, locale } = useIntl();

  const { formState, setValue } = useFormContext<IRegisterFormData>();

  return (
    <FormControl>
      <Stack spacing={2}>
        <Grid2 container spacing={2}>
          <Grid2 size={{ sm: 6, xs: 12 }}>
            <OutlinedTextField
              id="firstname-input"
              label={<FormattedMessage {...messages.registerFirstNameLabel} />}
              name="firstName"
              required
              fullWidth
            />
          </Grid2>
          <Grid2 size={{ sm: 6, xs: 12 }}>
            <OutlinedTextField
              id="lastname-input"
              label={<FormattedMessage {...messages.registerLastNameLabel} />}
              name="lastName"
              required
              fullWidth
            />
          </Grid2>
        </Grid2>
        <OutlinedTextField
          id="email-input"
          label={<FormattedMessage {...messages.registerEmailLabel} />}
          name="email"
          required
          type="email"
        />
        {!isOryRegistrationFFEnabled && (
          <PasswordInput
            id="password-input"
            label={formatMessage(messages.registerPasswordLabel)}
            name="password"
            required
            fullWidth
          />
        )}
        <OutlinedTextField
          id="companyname-input"
          label={<FormattedMessage {...messages.registerCompanyNameLabel} />}
          name="companyName"
          required
        />
        <OutlinedTextField
          label={formatMessage(messages.registerReferrerLabel)}
          name="referrer"
          select
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          sx={{ my: 0 }}
        >
          {getFeedbackOptions(formatMessage).map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </OutlinedTextField>
        <RegisterGtc />
      </Stack>
      <Box mt={2}>
        <Recaptcha
          expiredCallback={() => setValue('captcha', '')}
          hl={locale.toLocaleString()}
          key={locale} // to force re-initialization when language changes
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onloadCallback={() => {}}
          render="explicit"
          sitekey={process.env.RECAPTCHA_SITE_KEY}
          verifyCallback={(response) => {
            setValue('captcha', response, { shouldValidate: true });
          }}
        />
      </Box>
      {formState.errors.captcha && formState.dirtyFields.captcha && <p>{formState.errors.captcha.message}</p>}
      <Box sx={{ pt: 3 }}>
        <Button
          fullWidth
          disabled={!formState.isValid || isLoading}
          color="primary"
          id="creteaccount-button"
          size="large"
          type="submit"
          variant="contained"
          loading={isLoading}
          loadingPosition="start"
          startIcon={<Check />}
        >
          <FormattedMessage {...messages.RegisterImsConfirm} />
        </Button>
      </Box>
    </FormControl>
  );
}
